import React from 'react';
import './TracknTone.css';
import tracknToneLogo from '../assets/images/trackntone_1024.png';

function TracknTonePrivacy() {
  return (
    <div className="trackntone-page">
      <section className="trackntone-hero">
        <div className="trackntone-hero-inner">
          <img
            src={tracknToneLogo}
            alt="TracknTone logo"
            className="trackntone-logo-wow trackntone-logo-wow--small"
          />
          <h1>TracknTone Privacy Policy</h1>
          <p>Last updated: May 26, 2026</p>
        </div>
      </section>

      <section className="trackntone-content">
        <h2>Privacy Policy (plain-language)</h2>
        <p>
          TracknTone is a health companion app. We collect the information you provide so you
          can use the features of the app (for example: logging meals and tracking daily
          signals). If you choose to connect health integrations (like Apple Health or Google
          Fit), we use only the data you permit.
        </p>

        <h2>Information we may collect</h2>
        <ul>
          <li>Account information (for example: email/name) used to sign you in.</li>
          <li>
            Inputs you log in the app (for example: meal confirmations and progress signals).
          </li>
          <li>
            Health data from your device integrations only if you grant permission (for example:
            steps, water, and other supported signals).
          </li>
          <li>Usage/diagnostic data needed to run and improve the service.</li>
        </ul>

        <h2>How we use your information</h2>
        <ul>
          <li>To compute daily progress and display insights.</li>
          <li>To support optional features like Circles with buddies (opt-in sharing).</li>
          <li>To secure accounts and prevent abuse.</li>
        </ul>

        <h2>Sharing and visibility</h2>
        <p>
          Sharing is opt-in. If you join a Circle, only the information you choose to share
          in that Circle is visible to other Circle members. Health integrations sync with
          your device’s health provider only with your consent.
        </p>

        <h2>Your choices</h2>
        <ul>
          <li>
            You can revoke health integration permissions at any time in your device settings.
          </li>
          <li>You can adjust what you share in Circles inside the app.</li>
        </ul>

        <h2>Security</h2>
        <p>
          We use reasonable technical and organizational measures intended to protect information
          against unauthorized access, alteration, and loss. No method of transmission or storage
          is 100% secure.
        </p>

        <h2>Legal disclaimer (company protection)</h2>
        <p className="trackntone-disclaimer">
          This app and this website are provided as-is. Nothing in the app is medical advice.
          We make no guarantees about the accuracy, completeness, or usefulness of any
          information. You use the app at your own risk, and you are responsible for any decisions
          you make based on the information presented in the app.
        </p>

        <h2>Contact</h2>
        <p>
          Questions? Email{' '}
          <a href="mailto:tnt@northhawks.ca">tnt@northhawks.ca</a>.
        </p>
      </section>
    </div>
  );
}

export default TracknTonePrivacy;

